import { RegisterRoutes } from './type'

const root = `${RegisterRoutes.root}`
const multiorg = `${root}/${RegisterRoutes.multiorg}`

export const RegisterPath = {
  root: root,
  multiorg: multiorg,
}
